import React from "react";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";

interface MemberCountBadgeProps {
  count: number;
  className?: string;
}

const MemberCountBadge: React.FC<MemberCountBadgeProps> = ({ count, className = "" }) => {
  return (
    <Badge 
      variant="outline"
      className={`bg-slate-100 text-slate-700 border-slate-300 ${className}`}
    >
      <Users className="h-3 w-3 mr-1" />
      {count} {count === 1 ? 'Member' : 'Members'}
    </Badge>
  );
};

export default MemberCountBadge;
